// extracted by mini-css-extract-plugin
module.exports = {"editorsNote":"EditorsNote_editorsNote__1K5Vv","content":"EditorsNote_content__1Z3qD","label":"EditorsNote_label__ylo1v"};